package one.devsbox.www.tools

import tk.mallumo.compose.navigation.Navigation

fun Navigation.root(): Navigation {
    var navigation = this
    while (navigation.parentNavigation != null) {
        navigation = navigation.parentNavigation!!
    }
    return navigation
}